import React from 'react'
import ReactECharts from "echarts-for-react";
import { useSelector } from 'react-redux';
const DonutChart = ({title,report,day}) => {
   const mode = useSelector((state) => state.darkMode);
    const { isdarkMode } = mode;
const getDonutOption = (title) => ({
  backgroundColor: isdarkMode ? "" : "",
  tooltip: {
    trigger: "item"
  },
  legend: {
    bottom: 0,
    left: "center",
    textStyle: {
      color: isdarkMode ? "#ffffff" : "#000000" // legend text color
    }
  },
  series: [
    {
      name: title,
      type: "pie",
      radius: ["50%", "65%"],
      center: ["50%", "35%"],  
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 7,
        borderColor: isdarkMode ? "#222" : "#fff", // border color adjusts
        borderWidth: 2
      },
      label: {
        show: false,
        color: isdarkMode ? "#ffffff" : "#000000" // label color
      },
     emphasis: {
        label: {
          show: false   // ✅ disables black text on hover
        }
      },
      labelLine: {
        show: false 
      },
      data: convertMeterFormat(report)
    }
  ],
  color: pieColors
});

const pieColors = ["#5470C6", "#91CC75", "#FAC858", "#EE6666"];

//console.log(report)
 function convertMeterFormat(data ) {
  return data?.map((item) => ({
    value: day?item.dayConsumption:item.mtdConsumption,
    name: item.meterName || item.meterName, // fallback to original if no map
  }));
}
//console.log(convertMeterFormat(report))

  return (
    <div>
        <ReactECharts option={getDonutOption(title)} style={{ height: 250 }} />
      
    </div>
  )
}

export default DonutChart
